import { createAppStore } from "@/src/redux/createAppStore";

let clientApi: ReturnType<typeof createAppStore> | null = null;

export function getAppStoreApi() {
  if (!clientApi) {
    clientApi = createAppStore();
  }
  return clientApi;
}
